<template>
  <div>
    <Header />
    <Navigationzj />
    <div class="event-con" style="position: relative">
      <div class="menu-list">
        <ul>
          <li :class='{actived:flagd==index}' v-for="(item,index) in scene_Parent" :key="index" @click="getScenes(item.id,index)">
            <div class="el-icon-s-tools">
              <!-- <img :src="item.img" width="50px" height="50px"> -->
            </div>
            <div class="title"><strong>{{ item.title }}</strong></div>
          </li>
        </ul>
      </div>
      <div class="main-img">
        <div class="main-img-box">
          <div class="menu-ul">
            <ul>
              <li :class='{actived:flagdd==index}' v-for="(item,index) in scene" :key="index" :title="item.title" @click="showbanner(index,item)">
                <div><span class="el-icon-s-platform"></span>{{ item.title }}</div>
              </li>
            </ul>
          </div>
          <ul id="myBiaoZhu" class="img-ul" style="height: 499px; top: 0px;">
            <li v-show="flagdd==index" v-for="(item,index) in scene" :key="index" :style="'width: 1200px;height: 499px;background:url('+item.banner+') 0% 0% / 100% 100%;background-repeat: no-repeat;position: relative;'">
              <div v-for="(items,indexs) in item.children" :key="indexs" class="hot-dot round tooltip" :style="location(items.left,items.top)" @click="ordergoods(indexs,item)">
                <div class="divIMmg">
                    <div class="circle circle1"></div>
                    <div class="circle circle2 animation"></div>
                    <div class="circle circle3 animation2"></div>
                </div>
                <div class="tooltiptext">{{ items.title }}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="event-layout-row" v-for="(item,index) in levelgoods.slice(0 , 1)" :key="index" v-loading="loading">
        <!-- <div class="event-layout-row-con event-layout-row-con-3-1" style="float: left; width: 100%;margin-bottom: -55px;margin-top: 10px;">
          <div class="event-products-img" :id="'anchor-'+index">
              <div v-if="item.goods[0]" class="event-products-scene">
                <router-link :to="{path:'/Goods',query:{cid:item.goods[0].category_id}}" :title="item.title" target="_blank">
                  <span>{{ item.title }}</span>
                </router-link>
              </div>
              <div v-else class="event-products-scene">
                <span>{{ item.title }}</span>
              </div>
              <div v-if="item.goods[0]" class="event-products-scene-more">
                <router-link :to="{path:'/Goods',query:{cid:item.goods[0].category_id}}" title="查看更多" target="_blank">
                  <span style="color:#fff;">查看更多</span>
                </router-link>
              </div>
          </div>
        </div>
        <div class="clear"></div> -->
        <div class="event-layout-row-con" style="float: left; width: 20%;">
          <div class="side-select-wrap goods-select-side">
            <div class="left-header">
              <em v-if="item.goods[0]">
                <router-link :to="{path:'/Goods',query:{cid:item.goods[0].category_id}}" :title="item.title" target="_blank" style='color:#fff;'>...</router-link>
              </em>
              <em style='color:#fff;' v-else>...</em>
              <span>{{ item.title }}</span>
              <a class="reset-btn" @click="clearcheckbox()">清空筛选</a>
            </div>
            <ul>
              <li v-for="(item,index) in SameSpeci" :key="index" class="attr-item attr-item-iw">
                <div class="item-header">{{ item.param_name }}<i :class="item.open?'up-arrow':''" @click="changeopen(item)"></i></div>
                <div class="attr-option-container checkbox clearfix max-container" :style="item.open?'display:block;':'display:none'">
                  <ul class="checkbox-grop-wrap clearfix">
                    <li v-for="(items,indexs) in item.child" :key="indexs">
                      <el-checkbox class="checkbox-input" v-model="items.checked" @change="checkedFn(items)">{{ items.option_value }}</el-checkbox>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="event-layout-row-con" style="float: left; width: 80%">
          <div class="event-products">
            <div class="products clearfix">
              <div class="sku" v-for="(items,index) in item.goods" :key="index">
                <div class="sku-box">
                  <div class="product-picture">
                    <router-link :to="{path:'/GoodsDetail',query:{id:items.id}}" :title="items.title" target="_blank">
                      <img v-real-img="items.imgpath" src="../../assets/images/zwtp.jpg" :alt="items.title">
                    </router-link>
                  </div>
                  <div>
                    <div class="product-name">
                      <router-link :to="{path:'/GoodsDetail',query:{id:items.id}}" :title="items.title" target="_blank">
                        {{ items.title }}
                      </router-link>
                    </div>
                    <div class="product-price">
                      <span class="sale-price">{{ items.tax_price }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cght_cnxhtiwtjsp" v-if="emptyShow && item.goods.length==0">
              <div>
                <em class="myemptydata">暂无数据</em>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="cght_cnxhtiwtjsp" v-if="emptyShow && scene.length==0" style="height:500px;padding-top:230px;">
        <div>
          <em class="myemptydata">暂无数据</em>
        </div>
      </div>
    </div>
    <!-- <div class="left-side-menu" v-if="GoTopShow">
      <div class="third-catalogs-wrap">
        <ul class="third-catalogs-list" > -->
          <!-- <li :class='{active:flag==index}' :title="item.title" v-for="(item,index) in scene_Parent" :key="index">
            <a href="javascript:;" @click="getScenes(item.id,index)">{{ item.title }}</a>
          </li> -->
          <!-- <li :class='{active:flag==index}' :title="item.title" v-for="(item,index) in levelgoods" :key="index">
            <a @click="goAnchor('#anchor-'+index,index)">{{ item.title }}</a>
          </li>
          <li title='顶部' @click="toTop">
            <i class="el-icon-caret-top">顶部</i>
          </li>
        </ul>
      </div>
    </div> -->
    <Footer />
  </div>
</template>
<script>
import api from '@/api/scenes'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'

export default {
  name: 'Scenearea',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      scene_id: this.$route.query.scene_id,
      scene: [],
      scene_Parent: [],
      scroll: '', // 页面滚动的高度
      GoTopShow: false, // 是否显示
      emptyShow: false,
      loading: true,
      active: 'active',
      actived: 'actived',
      flag: 0,
      activeBtn: 0,
      flagd: 0,
      flagdd: 0,
      arrow: 'always',
      banMa: [], // 斑马线的数组
      canBiaoZhu: false, // 是否可以进行标注
      pointColor: '#436aa6', // 点的颜色
      pointSize: 15, // 点的大小
      levelgoods: [],
      SameSpeci: [],
      checkedarr: [], // 所选中的复选框
      screendata: [] // 删选原始数据
    }
  },
  watch: {
    scroll: function () {
      if (this.scroll > 500) {
        this.GoTopShow = true
      } else {
        this.GoTopShow = false
      }
    }
  },
  mounted () {
    this.getGroupList()
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    getScenes (scenenextid, i) {
      this.flagd = i
      this.loading = true
      api.getScenes({scene_next_id: scenenextid}).then(res => {
        let specdataInfo = []
        this.scene = res.items
        this.levelgoods = this.scene[0].children
        if (this.levelgoods.length > 0) {
          this.levelgoods[0]['goods'].map(res => {
            if (res.specParamList) {
              res.specParamList = JSON.parse(res.specParamList)
            }
            specdataInfo.push(res.specParamList)
            this.screendata.push(res)
          })
        } else {
          this.levelgoods = []
        }
        // 转化格式合并
        this.formatmerge(specdataInfo)
      })
      this.emptyShow = true
      this.loading = false
    },
    getGroupList () {
      api.getGroupList({scene_id: this.scene_id}).then(res => {
        this.scene_Parent = res.items[0].children
        if (res.items[0].children) {
          this.getScenes(res.items[0].children[0].id, 0)
        } else {
          this.emptyShow = true
        }
      })
    },
    handleScroll () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
    },
    toTop () {
      this.toTopSpeed = setInterval(() => {
        document.documentElement.scrollTop = document.documentElement.scrollTop - 20
        // 通过改变数字实现动画延迟滚动
        if (this.scroll < 10) {
          clearInterval(this.toTopSpeed)
        }
      }, 1)
    },
    // 锚点跳转
    goAnchor (selector, index) {
      this.flag = index
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
      })
    },
    arrows (num) {
      if (num > 5) {
        return 'always'
      } else {
        return 'never'
      }
    },
    // 点定位
    location (left, top) {
      left = parseInt(left) + document.getElementById('myBiaoZhu').offsetLeft - this.pointSize / 1.25
      top = parseInt(top) + document.getElementById('myBiaoZhu').offsetTop - this.pointSize / 1.25
      return {'left': left + 'px', 'top': top + 'px'}
    },
    showbanner (index) {
      this.levelgoods = this.scene[index].children
      this.flagdd = index
    },
    // 商品排序
    ordergoods (index) {
      this.levelgoods.map((item, i) => {
        if (i === index) {
          this.levelgoods.unshift(this.levelgoods.splice(index, 1)[0])
        }
      })
    },
    formatmerge (resData) {
      let dataInfo = []
      for (var i = 0; i < resData.length; i++) {
        for (var j = 0; j < resData[i].length; j++) {
          dataInfo.push(resData[i][j])
        }
      }
      this.arraymerge(dataInfo)
    },
    arraymerge (resData) {
      let dataInfo = {}
      resData.forEach((item, index) => {
        // eslint-disable-next-line camelcase
        let { param_name } = item
        if (!dataInfo[param_name]) {
          dataInfo[param_name] = {
            param_name,
            child: [],
            open: true
          }
        }
        dataInfo[param_name].child.push(item)
      })
      this.SameSpeci = Object.values(dataInfo) // list 转换成功的数据
      for (var i = 0; i < this.SameSpeci.length; i++) {
        this.SameSpeci[i].child = this.removeDuplicateObj(this.SameSpeci[i].child)
      }
      // console.log(this.SameSpeci)
    },
    // 去重
    removeDuplicateObj (arr) {
      var newarr = []
      var obj = {}
      for (var i = 0; i < arr.length; i++) {
        this.$set(arr[i], 'checked', false) // 这里，给对象添加属性，用$set方法。
        if (!obj[arr[i].option_value]) {
          newarr.push(arr[i])
          obj[arr[i].option_value] = true // 用来判断此对象已加入新数组
        }
      }
      return newarr
    },
    clearcheckbox () {
      for (var i = 0; i < this.SameSpeci.length; i++) {
        for (var j = 0; j < this.SameSpeci[i]['child'].length; j++) {
          this.SameSpeci[i]['child'][j].checked = false
        }
      }
      this.levelgoods[0]['goods'] = this.screendata
    },
    changeopen (item) {
      if (item.open) {
        item.open = false
      } else {
        item.open = true
      }
      // console.log(item)
    },
    // 复选框改变的方法
    checkedFn (item) {
      // console.log(item, 'item')
      // 每次选中前都清空
      this.checkedarr = []
      this.levelgoods[0]['goods'] = []
      for (var i = 0; i < this.SameSpeci.length; i++) {
        for (var j = 0; j < this.SameSpeci[i]['child'].length; j++) {
          if (this.SameSpeci[i]['child'][j].checked) {
            this.checkedarr.push(this.SameSpeci[i]['child'][j])
          }
        }
      }
      for (var x = 0; x < this.screendata.length; x++) {
        for (var y = 0; y < this.screendata[x]['specParamList'].length; y++) {
          for (var z = 0; z < this.checkedarr.length; z++) {
            if (this.checkedarr[z]['param_name'] === this.screendata[x]['specParamList'][y]['param_name'] && this.checkedarr[z]['option_value'] === this.screendata[x]['specParamList'][y]['option_value']) {
              this.levelgoods[0]['goods'].push(this.screendata[x])
            }
          }
          // console.log(this.screendata[x]['specParamList'][y])
          // console.log(this.checkedarr)
        }
      }
      if (this.levelgoods[0]['goods'].length === 0) {
        this.levelgoods[0]['goods'] = this.screendata
      }
    }
  }
}
</script>
<style scoped>
.atpresent_title {
  font-weight: 600;
}
</style>
<style>
.left-side-menu {
  position: fixed;
  width: 150px;
  top: 124px;
  left: 10%;
  z-index: 99;
}
.third-catalogs-wrap {
  font-size: 14px;
}
.third-catalogs-wrap .third-catalogs-list {
  padding: 0 22px;
  margin-top: 10px;
  border: 1px solid #e2e2e2;
}
.third-catalogs-wrap .third-catalogs-list li {
  width: 90%;
  height: 42px;
  line-height: 42px;
  padding-left: 8px;
  padding-right: 12px;
  border-bottom: 1px dashed #dcdcdc;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  cursor: pointer;
}
.third-catalogs-wrap .third-catalogs-list li a {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.third-catalogs-wrap .third-catalogs-list li i {
  padding-left: 15px;
}
a {
  color: #666;
  cursor: pointer;
}
.third-catalogs-wrap .third-catalogs-list li a:hover {
  color: #436aa6;
  font-weight: 700;
}
.third-catalogs-wrap .third-catalogs-list li.active {
  position: relative;
  color: #436aa6;
  font-weight: 700;
}
.third-catalogs-wrap .third-catalogs-list li.active a {
  color: #436aa6;
}
/* common */

.event-layout-row div {
  border: 0 none;
  box-sizing: border-box;
  font-family: "Microsoft Yahei";
  font-size: 100%;
  font-style: inherit;
  font-weight: inherit;
  outline: 0 none;
  padding: 0;
  vertical-align: baseline;
}
.event-con img {
  border: 0 none;
  box-sizing: border-box;
  font-family: "Microsoft Yahei";
  font-size: 100%;
  font-style: inherit;
  font-weight: inherit;
  outline: 0 none;
  padding: 0;
  vertical-align: baseline;
}
.event-con {
  width: 100%;
  margin: 0 auto;
}
.menu-list {
  /* background-color: #436aa6; */
}
.menu-list ul {
    margin: 0 auto;
    text-align: center;
    width: 1200px;
    background-color: #e6e6e6;
}
.menu-list ul li.actived .title{
  color: #fff;
  background-color: #039;
}
.menu-list ul li.actived {
  background-color: #039;
}
.menu-list ul li {
    display: inline-block;
    height: 100px;
    max-width: 146px;
    width: 100%;
    margin: 0 8px;
    color: #fff;
    cursor: pointer;
}
.menu-list ul li {
    color: #fff;
    font-size: 14px;
    padding: 0;
}
.menu-list .el-icon-s-tools {
    width: 50px;
    height: 50px;
    margin: 5px auto;
    font-size: 50px;
    color: #000000;
}
.menu-list .title {
    height: 20px;
    font-weight: 400;
    font-size: 28px;
    color: #000000;
}
.menu-list ul li.actived .el-icon-s-tools{
  color: #fff;
}
.clear {
  width: 100%;
  clear: both;
}
.event-layout-row {
  width: 1200px;
  margin: 0 auto !important;
  padding-top: 25px;
}
.event-layout-row-0 {
  width: 100%;
}
.event-con ol,
.event-con ul {
  list-style: outside none none;
}
/* diy */
.clearfix::after {
  clear: both;
  content: ".";
  display: block;
  height: 0;
  visibility: hidden;
  width: 0;
}

.event-products .products {
  margin: 0 -5px;
}
.event-products .products .sku {
  float: left;
  height: 330px;
  width: 25%;
  overflow: hidden;
  padding: 0 5px 10px 5px;
}
.event-products .products .sku .sku-box {
  background: #ffffff none repeat scroll 0 0;
  width: 100%;
  height: 100%;
  padding: 15px 15px;
}
.event-products .products .sku .product-picture {
  position: relative;
}
.event-products .products .sku img {
  height: 210px;
  width: 210px;
  outline: 0 none;
}
.event-products .products .sku img:hover {
  opacity: 0.9;
}
.event-products .products .sku .product-name {
  font-family: "PingFangSC-Regular", "Microsoft Yahei", "黑体", sans-serif;
  font-size: 14px;
  margin: 8px 0;
  overflow: hidden;
  height: 40px;
}
.event-products .products .sku a {
  color: #333333;
  text-decoration: none;
}
.event-products .products .sku a:hover {
  color: #007857;
}
.event-products .products .sku .sale-price {
  color: #436aa6;
  font-family: "PingFangSC-Medium", "Century Gothic", "Microsoft YaHei",
    sans-serif;
  font-size: 22px;
  line-height: 24px;
  margin-right: 4px;
  font-weight: 700;
}
.event-products .products .sku .sale-price::before {
  content: "￥";
}
.event-con {
  /* background-color: #f8fdff; */
  background: url(../../assets/images/bannerbk2.jpg) no-repeat center 0px;
}
.event-products .products .sku-box:hover {
  border: solid;
  border-color: #ececed;
}
.event-products-img {
  width: 100%;
  height: 63px;
  text-align: center;
  background-image:url('../../assets/images/zp_64.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.event-products-scene {
  width: 217px;
  height: 121px;
  line-height: 60px;
  margin-left: 52px;
  float: left;
}
.event-products-scene span{
  color: #fff;
  font-weight: bold;
  font-size: 25px;
  letter-spacing: 15px;
  font-style: italic;
}
.event-products-scene-more{
  width: 180px;
  height: 121px;
  line-height: 60px;
  margin-left: 716px;
  float: left;
}
#myBiaoZhuDiv{
  position: relative;
}
#myBiaoZhuDiv img {
  text-align: center;
  width: 100%;
  height: 499px;
  display: inline-block;
  z-index: 1;
}
#myBiaoZhuDiv .marker {
  border: 2px solid #fff;
  position:absolute;
  border-radius: 50%;
  z-index: 999;
  -webkit-animation: twinkling 2s infinite ease-in-out;
}
.animated{
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both
}
@-webkit-keyframes twinkling{
  0%{
    opacity: 0.5;
  }
  100%{
    opacity: 1;
  }
}
@keyframes twinkling{
  0%{
    opacity: 0.5;
  }
  100%{
    opacity: 1;
  }
}
.cght_cnxhtiwtjsp{ height:167px; width:100%; padding-top:175px;}
.cght_cnxhtiwtjsp div{ width:200px; text-align:center; padding-left:100px; background:url(../../assets/images/spsc_img02.png) no-repeat left center; height:60px; line-height:60px;font-size:18px; color:#959595; margin:0px auto; clear:both;}
.myemptydata {color:#959595}

.main-img {
  /* background:url(../../assets/images/hbj.png) */
}
.main-img-box {
  position: relative;
  overflow: hidden;
  width: 1200px;
  margin: 0 auto;
  z-index: 5;
}
.menu-ul {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 230px;
  z-index: 8;
  /* background: rgba(5,4,4,0.4); */
  vertical-align: middle;
}
.menu-ul ul {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}
.menu-ul li.actived {
  background: #436aa6;
  /* box-shadow: 0 -1px 0 0 rgb(255 255 255 / 50%); */
  color: #fff;
}
.menu-ul li {
  width: 100%;
  height: 42px;
  line-height: 42px;
  margin: 10px auto;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.7);
  position: relative;
  display: inline-block;
  background: #dedfe0;
}
.menu-ul li.actived div {
  color: #fff;
  font-weight: 500;
}
.menu-ul li div {
  font-weight: 500;
  color: #5c6062;
  font-size: 16px;
  letter-spacing: 5px;
  margin: 0 auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  padding-left: 30px;
}
.menu-ul li.actived::after {
  color: #fff;
  font-weight: 500;
}
.menu-ul li::after {
  content: '>';
  width: 16px;
  height: 16px;
  position: absolute;
  top: -2px;
  right: 14px;
  font-size: 16px;
  color: #5c6062;
}
.main-img .img-ul {
  position: relative;
  top: 0;
}
.main-img .img-ul li {
  overflow: hidden;
  background-repeat: no-repeat;
  background-size: 100%;
}
.hot-dot {
  width: 24px;
  height: 24px;
  position: absolute;
  z-index: 20;
  border-radius: 50%;
  cursor: pointer;
}
.hot-dot .divIMmg .circle1 {
  width: 8px;
  height: 8px;
  margin: -6px 0 0 -6px;
  border: 2px solid #fff;
  background-color: #6788bb;
  z-index: 40;
}
.hot-dot .divIMmg .circle {
  position: absolute;
  left: 50%;
  top: 50%;
  border-radius: 50%;
}
.hot-dot .divIMmg .circle2 {
    width: 16px;
    height: 16px;
    margin: -8px 0 0 -8px;
    background-color: #fff;
    z-index: 30;
}
.hot-dot .divIMmg .circle3 {
    width: 22px;
    height: 22px;
    margin: -11px 0 0 -11px;
    z-index: 20;
}
.tooltip .tooltiptext {
  font-style: normal;
  visibility: hidden;
  width: 150px;
  height: 24px;
  line-height: 24px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 150%;
  left: 50%;
  margin-left: -75px;
}
.tooltip .tooltiptext {
  color: #6E6E6E;
  background: #fff;
  width: auto;
  line-height: 22px;
  left: 24px;
  top: -2px;
  text-align: left;
  font-size: 16px;
  padding: 2px 5px 2px 8px;
  white-space: nowrap;
  margin-left: 0;
}
.tooltip:hover{
  z-index: 100;
}
.tooltip:hover .tooltiptext{
  visibility: visible;
}
.animation, .animation2 {
  -webkit-animation: twinkling 1s infinite ease-in-out;
  animation: twinkling 1s infinite ease-in-out;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
/* 新加 */
.side-select-wrap {
    float: left;
    width: 230px;
  }
  .side-select-wrap .left-header {
    height: 50px;
    line-height: 25px;
    padding: 10px;
    color: #fff;
    font-size: 17px;
    font-weight: 700;
    background-color: #657597;
    text-align: left;
  }
  .side-select-wrap .left-header em {
    display: inline-block;
    border: 1px solid #fff;
    width: 25px;
    height: 25px;
    line-height: 15px;
    text-align: center;
    font-weight: 900;
    margin-right: 10px;
    vertical-align: middle;
  }
  .side-select-wrap .left-header .reset-btn {
    font-size: 12px;
    height: 25px;
    border: 1px solid #fff;
    color: #fff;
    padding: 0 6px;
    float: right;
    margin-right: 10px;
    border-radius: 4px;
    cursor: pointer;
  }
  .side-select-wrap .attr-item {
    border: 1px solid #e2e2e2;
    border-bottom: none;
    padding: 0;
  }
  .side-select-wrap .attr-item .item-header {
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    background: #f7f7f7;
    color: #666;
    font-size: 12px;
    font-weight: 700;
    text-align: left;
  }
  .side-select-wrap .attr-item .item-header i.up-arrow {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-filter: FlipV;
    filter: FlipV;
  }
  .side-select-wrap .attr-item .item-header i {
    float: right;
    margin-top: 5px;
    margin-right: 5px;
    width: 20px;
    height: 20px;
    background: url(../../assets/images/xjt.png) center 50% no-repeat;
    cursor: pointer;
  }
  .side-select-wrap .attr-item .attr-option-container {
    border: 1px solid #fff;
    padding: 20px 0 5px 10px;
    /* max-height: 272px; */
    overflow: auto;
  }
  .side-select-wrap .attr-item:last-child {
    border-bottom: 1px solid #e2e2e2;
  }
  .checkbox-grop-wrap {
    font-size: 12px;
  }
  .side-select-wrap .attr-item.attr-item-iw .checkbox-grop-wrap li {
    width: 100%;
  }
  .side-select-wrap .attr-item .attr-option-container .checkbox-grop-wrap li {
    width: 50%;
    text-align: left;
    margin-bottom: 15px;
  }
  .checkbox-grop-wrap li {
    float: left;
  }
  .side-select-wrap .attr-item .attr-option-container .checkbox-grop-wrap li .checkbox-wrap {
    padding-left: 18px;
    white-space: break-spaces;
    max-width: 168px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .checkbox-wrap {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
    outline: none;
    display: inline-block;
    position: relative;
    line-height: 1;
    line-height: 20px;
    margin: 0 5px;
  }
  .checkbox-wrap, .pagination .vertical-middle {
    vertical-align: middle;
  }
  .checkbox-wrap input[type=checkbox] {
    box-sizing: border-box;
    padding: 0;
  }
  .checkbox-wrap .checkbox-input {
    position: absolute;
    left: 0;
    z-index: 9999;
    cursor: pointer;
    opacity: 0;
    top: 2px;
    margin-right: 4px;
    bottom: 0;
    right: 0;
    line-height: normal;
  }
  .side-select-wrap .attr-item .attr-option-container .checkbox-grop-wrap li .checkbox-wrap .checkbox-inner {
    position: absolute;
    top: 3px;
  }
  .clearfix:after {
    clear: both;
    content: " ";
    display: block;
    font-size: 0;
    line-height: 0;
    visibility: hidden;
    width: 0;
    height: 0;
  }
/* 新加 */
</style>



// WEBPACK FOOTER //
// src/view/scenearea/index.vue